import { QUICK_FILTERS_CHANGE, QUICK_FILTERS_RESET } from './constants'

const quickFiltersChange = (array) => ({
  type: QUICK_FILTERS_CHANGE,
  payload: { array },
})
const quickFiltersReset = () => ({ type: QUICK_FILTERS_RESET })

export default {
  quickFiltersChange,
  quickFiltersReset,
}
